import { Glide, styled, CustomLink, SubTitle } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import React, { useCallback } from 'react';
import { t } from '../../i18n.es.js';
import { BlockHeader } from '../BlockHeader/BlockHeader.es.js';
import { EnhancedImage } from '../EnhancedImage/EnhancedImage.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Category = (_a) => {
  var _b = _a, {
    regionName,
    targetName,
    index
  } = _b, item = __objRest(_b, [
    "regionName",
    "targetName",
    "index"
  ]);
  return /* @__PURE__ */ React.createElement(Item, __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName,
    contentName: item.id,
    target: targetName,
    index
  })), /* @__PURE__ */ React.createElement(CustomLink, __spreadValues({}, item.link), /* @__PURE__ */ React.createElement(EnhancedImage, __spreadProps(__spreadValues({
    width: 56,
    height: 56,
    objectFit: "cover"
  }, item.image), {
    alt: item.title,
    googleImageParams: { width: 112 }
  })), /* @__PURE__ */ React.createElement(SubTitle, {
    marginTop: "s8",
    level: 2,
    line: 2,
    weight: "regular",
    hoverColor: "primary500"
  }, item.title)));
};
const ListCategories = ({
  header,
  categories,
  regionName,
  targetName,
  isHeadingTitle = false
}) => {
  const renderCategories = useCallback((categories2) => {
    if (categories2.length > 10) {
      return /* @__PURE__ */ React.createElement(Glide, {
        perView: 10,
        perSwipe: "|",
        type: "carousel",
        autoplay: 2e3,
        dragThreshold: false,
        showControl: false
      }, categories2.map((item, index) => /* @__PURE__ */ React.createElement(Category, __spreadValues({
        key: index,
        index,
        regionName,
        targetName
      }, item))));
    } else {
      return /* @__PURE__ */ React.createElement(ContentBlock, null, categories2.map((item, index) => /* @__PURE__ */ React.createElement(Category, __spreadValues({
        key: index,
        index,
        regionName,
        targetName
      }, item))));
    }
  }, [regionName, targetName]);
  return /* @__PURE__ */ React.createElement(ListCategoriesWrapper, null, /* @__PURE__ */ React.createElement(BlockHeader, __spreadProps(__spreadValues({}, header), {
    title: header.title || t("Danh m\u1EE5c s\u1EA3n ph\u1EA9m"),
    isHeadingTitle
  })), renderCategories(categories));
};
const Item = styled.div`
  text-align: center;
  flex: 1;
`;
const ListCategoriesWrapper = styled.div`
  background: white;
  border-radius: 8px;
`;
const ContentBlock = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 16px 24px 16px;
  text-align: center;
  gap: 16px;
`;

export { ListCategories };
